import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type EventMerchantOrderSharedLinkInfoFragmentFragment = { __typename?: 'EventMerchantOrderSharedLinkInfo', can_submit_or_edit: boolean, event?: { __typename?: 'EventInfoForSharedLink', id: string, name?: string | null, currency: string, vat_rate?: number | null, minimum_cleaning_fee_rate?: number | null, start_date?: string | null, end_date?: string | null, merchant_order_form_deadline?: string | null, merchant_order_form_info_text?: string | null, allowed_container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image_url?: string | null, segment?: Types.ContainerTypeSegment | null, size_helper?: string | null, packing_unit?: number | null, color_hex_code?: string | null }>, allowed_item_types: Array<{ __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory }>, head_of_operations?: { __typename?: 'ZohoUser', id: string, full_name?: string | null, phone?: string | null, mobile?: string | null, email?: string | null } | null, event_manager?: { __typename?: 'ZohoUser', id: string, full_name?: string | null, phone?: string | null, mobile?: string | null, email?: string | null } | null } | null, prices?: Array<{ __typename?: 'EventPrice', kind: Types.EventPriceKind, container_type_id?: number | null, item_type_id?: number | null, rental_price?: number | null, cleaning_price?: number | null, deposit_price?: number | null, lost_price?: number | null, is_default: boolean }> | null, event_account?: { __typename?: 'EventAccountInfoForSharedLink', id: string, name?: string | null, description?: string | null, billing_email?: string | null, billing_first_name?: string | null, billing_last_name?: string | null, phone_number?: string | null, billing_additional_address_info?: string | null, billing_city?: string | null, billing_country_code?: string | null, billing_mail?: string | null, billing_state?: string | null, billing_street?: string | null, billing_zip?: string | null, company_name?: string | null, corporate_structure_info?: string | null, date_of_birth?: string | null, vat?: string | null, business_type?: Types.BusinessType | null, item_locations: Array<{ __typename?: 'ItemLocationReduced', id: string, type?: string | null, name?: string | null }> } | null, ops_order?: { __typename?: 'MerchantOrderInfo', id: string, created_timestamp: string, status: Types.MerchantOrderStatusEnum, comment?: string | null, latest_revision?: { __typename?: 'MerchantOrderRevisionInfo', modified_timestamp: string, containers: Array<{ __typename?: 'MerchantOrderContainerInfo', item_location_id?: string | null, type_id: number, amount_int: number, unit: Types.MerchantOrderItemUnit }>, items: Array<{ __typename?: 'MerchantOrderItemInfo', item_location_id?: string | null, item_type_id: number, amount_int: number, unit: Types.MerchantOrderItemUnit, item_type?: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null } | null }> } | null } | null };

export const EventMerchantOrderSharedLinkInfoFragmentFragmentDoc = gql`
    fragment eventMerchantOrderSharedLinkInfoFragment on EventMerchantOrderSharedLinkInfo {
  event {
    id
    name
    currency
    vat_rate
    minimum_cleaning_fee_rate
    start_date
    end_date
    allowed_container_types {
      id
      name
      image_url
      segment
      size_helper
      packing_unit
      color_hex_code
    }
    allowed_item_types {
      id
      name
      image_url
      color_hex_code
      category
    }
    merchant_order_form_deadline
    merchant_order_form_info_text
    head_of_operations {
      id
      full_name
      phone
      mobile
      email
    }
    event_manager {
      id
      full_name
      phone
      mobile
      email
    }
  }
  prices {
    kind
    container_type_id
    item_type_id
    rental_price
    cleaning_price
    deposit_price
    lost_price
    is_default
  }
  event_account {
    id
    name
    description
    billing_email
    billing_first_name
    billing_last_name
    item_locations {
      id
      type
      name
    }
    phone_number
    billing_additional_address_info
    billing_city
    billing_country_code
    billing_mail
    billing_state
    billing_street
    billing_zip
    company_name
    corporate_structure_info
    date_of_birth
    vat
    business_type
  }
  ops_order {
    id
    created_timestamp
    status
    comment
    latest_revision {
      modified_timestamp
      containers {
        item_location_id
        type_id
        amount_int
        unit
      }
      items {
        item_location_id
        item_type_id
        amount_int
        unit
        item_type {
          id
          name
          image_url
          color_hex_code
        }
      }
    }
  }
  can_submit_or_edit
}
    `;